import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import stylesCommon from "../../common.module.scss"
import CustomLists from '../../../custom/custom-lists/CustomLists';
import CustomButton from '../../../custom/custom-button/CustomButton';
import { useRegistration } from '../../../../hooks/useRegistration';

export const USER_ROLE = {
  HEAD: "head",
  EMPLOYEE: "employee",
};

const SurveyUserRegistrationThird = ({ updateStep, setData, data, code, clientId}) => {
  const { t } = useTranslation();
  const { isLoading, performRegistration } = useRegistration();
  const [isCheck, setIsCheck] = useState(data.isHead !== undefined ? data.isHead : false);

  const items = [
    {
      text: t('registrationSurveyUserThird.role.head'),
      summary: "",
      value: USER_ROLE.HEAD,
    },
    {
      text: t('registrationSurveyUserThird.role.employee'),
      summary: "",
      value: USER_ROLE.EMPLOYEE,
    },
  ];

  const activeChoiceIndex = data?.isHead ? 0 : (data?.role === USER_ROLE.EMPLOYEE ? 1 : null);

  const handleUserRoleChange = (selectedIndex) => {
    const selectedValue = items[selectedIndex].value;
    setData({ ...data, isHead: selectedValue === USER_ROLE.HEAD });
    setIsCheck(true);
  };

  const nextStep = async () => {
    if (isCheck) {
      try {
        await performRegistration(data, code, clientId);
      } catch (error) {
        // Error already handled in hook
      }
    }
  };

  return (
    <div className={stylesCommon.fullWidth}>
      <CustomLists
        items={items}
        isRadioBtn={true}
        onSelectionChange={handleUserRoleChange}
        activeChoice={activeChoiceIndex} />
      <div className={stylesCommon.mrXmedium}>
        <CustomButton isFall isLoading={isLoading} isDisabled={!isCheck} text={t('registrationSurveyUserThird.button.login')} onClick={nextStep} />
      </div>
    </div>
  );
};

export default SurveyUserRegistrationThird;
